import { UserGroups } from '@/helpers/enums';
import {getL2AdminID} from '@/helpers/Utils';

export default {
	computed: {
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
		getUser() {
			return this.$store.getters.getUser;
		},
		getUserCompany() {
			return this.getUser.person.company;
		},
		isLocalAuthorized() {
			return this.$store.getters.isLocalAuthorized;
		},
		isLocalAuthorizationExpired() {
			return this.$store.getters.isLocalAuthorizationExpired;
		},
		isAuthenticatedUserInGroupAdmin() {
			return this.$store.getters.getUser.usergroup?.name === UserGroups.ADMIN;
		},
		isAuthenticatedUserInGroupMitarbeiter() {
			return this.$store.getters.getUser.usergroup?.name === UserGroups.EMPLOYEE;
		},
		isUserAllowedInLevel1() {
			const hasLvl1 = this.$store.getters.getAuthenticatedUserGroupLevel === '1';
			const is_Admin = this.$store.getters.isLevelAdmin;
			return hasLvl1 && is_Admin;
		},
		isUserAllowedInLevel2() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '2';
		},
		isUserAllowedInLevel3() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '3';
		},
		isUserAllowedInLevel4() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '4';
		},
		isUserAllowedInLevel5() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '5';
		},
		isUserAllowedInLevel6() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '6';
		},
		isUserAllowedInLevel5or6() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '5' || this.$store.getters.getAuthenticatedUserGroupLevel === '6';
		},
		isLevel1() {
			return this.$store.getters.getAuthenticatedUserGroupLevel === '1';
		},
		isLevel1Admin() {
			return this.isUserAllowedInLevel1 && this.$store.getters.isLevelAdmin;
		},
		isLevel2Admin() {
			return this.isUserAllowedInLevel2 && this.$store.getters.isLevelAdmin;
		},
		isAdAdmin() {
			return this.$store.getters.getUser.isAdAdmin;
		},
		isParentCompany() {
			return this.$store.getters.getUser.CompanyRelationshipType === 'parent';
		},
		isIMDAdminCompany() {
			return this.$store.getters.getUser.person.company.id === getL2AdminID();
		},
	},
};
